(function() {
	'use strict';
	var
		collapselinks = document.querySelectorAll('.collapse-btn.hae-btn'),
		scrollToTarget = function(buttons){
			buttons.forEach(function(button) {
				button.addEventListener("click",function(e) {
					document.querySelector(e.currentTarget.getAttribute('data-bs-target')).scrollIntoView();
				});
			});
		};

		scrollToTarget(collapselinks);

	// // VIDEO AUTOPLAY FIX GLOWEB-9377
	// // Select all elements with the class `.icon-play-l`
	// var playIcons = document.querySelectorAll('.icon-play-l');

	// // Add a click event listener to each selected element
	// playIcons.forEach(function(playIcon) {
	// 	playIcon.addEventListener('click', function() {
	// 		// Select the first element with the class `.modal-video`
	// 		const video = document.querySelector('.modal-video');

	// 		// Check if the video element exists
	// 		if (video) {
	// 			// Get the current `src` attribute of the video
	// 			const videoSrc = video.getAttribute('src');

	// 			// Add `autoplay=1` to the `src` to enable autoplay when clicked
	// 			video.setAttribute('src', videoSrc + '&autoplay=1');
	// 		}
	// 	});
	// });
	
})();
